import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import queryString from 'query-string';
import { Popup } from 'components/Popup/popup';
import TagsInput from 'components/tag-input';

import * as WorkOrderActionType from '../constants';

const popupStyle = {
  right: 0,
  top: '15px',
  width: '300px',
  padding: '10px 0'
};

const TAGS_LIST = [9, 13, 188];

export class EmailPopup extends React.Component {
    static propTypes = {
      onSendEmail: PropTypes.func,
      onClose: PropTypes.func,
      location: PropTypes.object,
      dispatch: PropTypes.func,
      objToParams: PropTypes.func,
      workOrder:PropTypes.string,
      clearSearch:PropTypes.func
    }

    constructor(props) {
      super(props);

      // var now = new Date();
      // var strNow = (now.getMonth() + 1) + '-' + now.getDate() + '-' + now.getFullYear();

      this.state = {
        // name: 'WorkOrders_' + strNow,
        recipientEmails: [],
        suggestions:[]
      };
    }
    componentDidMount() {
      this.onFetchAllEmails();
    }

    onFetchAllEmails = () => {
      this.props.dispatch({
        type: WorkOrderActionType.GET_ALL_USER_EMAILS,
        params: {  },
        callback: (res, isSuccess) => {
          this.setState({
            ...this.state,
            suggestions: res
          });
        }
      });
    };


    onCloseEmailBox = () => {
      this.props.onClose();
    }

    onClickSendInEmailBox = () => {
      this.props.onSendEmail();
    }

    onChangeEmail = (tags) => {
      let tagsValid = [];
      let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;

      tags.map(tag => {
        if (emailPattern.test(tag)) {
          tagsValid.push(tag);
        }
      });

      this.setState({recipientEmails: tagsValid });
    }

    isInvalid = () => {
      return (this.state.recipientEmails.length === 0);
    }

    onSendEmail = () => {
      let urlParams = queryString.parse(window.location.search);
      let exportParams = { ...urlParams, skip: '', take: '', recipients: this.state.recipientEmails.join(',') };
      if(this.props.workOrder === 'List'){
        this.props.clearSearch();
        this.props.dispatch({
        type: WorkOrderActionType.EXPORT_WORK_ORDER_LIST,
        params: this.props.objToParams({ ...exportParams }),
        callback: this.props.onClose
      });
    }else{
      this.props.dispatch({
        type: WorkOrderActionType.SEND_EMAIL_WO_DETAIL,
        params:this.props.objToParams({ ...exportParams }),
        callback: this.props.onClose
      });
    }
    };

    render() {
      return (
        <React.Fragment>
          <Popup className='reopen-popup' isHasFaded={true} styles={popupStyle}>
            <div className='recipients-email-eoc container-fluid'>
              <button type='button' className='close' onClick={this.onCloseEmailBox}>&times;</button>
              <label>Recipients&nbsp;<span className='text-danger'>*</span></label>
              <TagsInput
                value={this.state.recipientEmails}
                onChange={tags => { this.onChangeEmail(tags, 0); }}
                inputProps={{placeholder: 'Type email address'}}
                onlyUnique={true}
                addKeys={TAGS_LIST}
                suggestions={this.state.suggestions}
                addOnBlur
                autoFocus
                autocomplete={true}
              />
              <button className='btn btn-primary btn-siteone' style={{marginTop: 10}}
                disabled={this.isInvalid()} onClick={this.onSendEmail} >Send</button>
            </div>
          </Popup>
        </React.Fragment>
      );
    }
}

export default connect()(EmailPopup);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/EmailPopup.js